import React from "react";
import { Spinner } from "./Spinner";
import { buttonClassName, type ButtonSize, type ButtonVariant } from "./buttonStyles";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
}

const spinnerSizeMap: Record<ButtonSize, "xs" | "sm"> = {
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "sm",
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      size = "md",
      loading = false,
      icon,
      iconRight,
      children,
      className = "",
      disabled,
      ...rest
    },
    ref
  ) => {
    const isDisabled = disabled || loading;
    const iconOnly = !children && Boolean(icon || iconRight || loading);

    return (
      <button
        ref={ref}
        disabled={isDisabled}
        className={buttonClassName({ variant, size, iconOnly, className })}
        {...rest}
      >
        {loading ? (
          <Spinner size={spinnerSizeMap[size]} className="shrink-0" />
        ) : icon ? (
          <span className="shrink-0">{icon}</span>
        ) : null}
        {children && <span>{children}</span>}
        {!loading && iconRight && (
          <span className="shrink-0">{iconRight}</span>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";
